
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ContainerBox from 'layouts/UIElements/ContainerBox/ContainerBox';
import { withRouter } from 'helpers/ModuleHelper';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import * as actions from 'store/actions';
import { injectIntl } from 'react-intl';
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import * as fieldHelper from "helpers/FieldHelper";
import { getThumbUrl, getImgUrl } from "helpers/ImageHelper";
import { onFullScreenClick } from "helpers/PageHelper";
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { getMediaTypeObj, getDefaultImg, getMfxInfoFromSourcefile } from 'helpers/FileHelper';
import { isHome } from 'helpers/AppHelper';
import { handleNext } from "helpers/DetailHelper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { parseStringField } from "helpers/FieldHelper";

import './ClipDetail.scss';

const ClipDetail = observer(
    class ClipDetail extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                currentClip: { title: '' },
                viewMode: ConfigTypes.DETAIL,
                mediaUrl: "",
                fullMediaUrl: ""
            }
        }

        updateClip = () => {
            const { currentClip } = this.props.mediaObjects;
            if (currentClip) {
                console.log("LOGS: currentClip", currentClip);
                this.setState({ currentClip: currentClip }, () => {
                    let elements;
                    if (currentClip && currentClip.mediafiles && currentClip.mediafiles.elements) {
                        elements = currentClip.mediafiles.elements;
                    }
                    let mediaTypeObj = getMediaTypeObj({ elements, clip: currentClip });
                    if (mediaTypeObj) {
                        this.setState({ mediaUrl: mediaTypeObj.mediaUrl, mediaTypeObj });
                    }
                });
            }
        }

        formatMessage = ({ id }) => {
            return this.props.intl.formatMessage({ id });
        }

        onMediaFileClick = (item) => () => {
            if (item && item.path && item.filename) {
                let mediaUrl = getThumbUrl({ item });
                let fullMediaUrl = getThumbUrl({ item, fullScreen: true });
                this.setState({
                    mediaTypeObj: {
                        ...this.state.mediaTypeObj, mediaUrl, curMediafile: item
                    }, fullMediaUrl
                });
            }
        }

        showMfxTxt = (label, objTxt, last = false) => {
            if (label && objTxt) {
                return (
                    <span className="clipdetail-mfxtxt">
                        {this.props.intl.formatMessage({ id: `clipdetail.${label}` })}: {objTxt}
                        {!last && ', '}
                    </span>
                )
            }
        }

        getMfxContent = (obj) => {
            return (
                <div>
                    {this.showMfxTxt("format", obj.format)}
                    {this.showMfxTxt("dimension", obj.dimension)}
                    {this.showMfxTxt("colorspace", obj.colorspace, true)}
                </div>
            )
        }

        showMediafileInfo = () => {
            const { mediaTypeObj } = this.state;
            const { mediafiles } = this.state.currentClip;
            if (this.state.currentClip) {
                let creator, content = '';
                const { metadata } = this.state.currentClip;
                if (metadata && metadata.fields && metadata.fields.borndigital
                    && +metadata.fields.borndigital == 1) {
                    if (metadata.fields.txt5) {
                        let tmp = parseStringField(metadata.fields.txt5);
                        if (tmp) creator = <div>&copy;	{tmp} </div>
                    }
                }
                let obj = getMfxInfoFromSourcefile({ mediaTypeObj, mediafiles });
                if (obj) content = this.getMfxContent(obj);
                return (<div>{creator}{content}</div>)
            }
        }

        showMediafiles = () => {
            const { currentClip } = this.props.mediaObjects;
            if (currentClip && currentClip.mediafiles
                && currentClip.mediafiles.elements && currentClip.mediafiles.elements.length > 1)
                return (
                    <div className="clipdetail-mediafile-box">
                        {currentClip.mediafiles.elements.map((item, index) => {
                            if (item.data && item.data.tags && item.data.tags.includes("preview"))
                                return (
                                    <div className="clipdetail-mediafile-img" key={`mediafile_${index}`}>
                                        <img className="img-responsive img-rounded"
                                            onClick={this.onMediaFileClick(item)} src={item.url} alt="" />
                                    </div>)
                        })}
                    </div>)
        }


        showClipContent = ({ showFields }) => {
            let labelClass = "col-lg-5 col-md-4 col-sm-4 clipdetail-bold";
            return (
                <Fragment>
                    <div className="clipdetail-content">
                        {showFields.map((el, i) => {
                            if (el[`${this.state.viewMode}group`]) {
                                if (el[`${this.state.viewMode}group`].isFirst) {
                                    return fieldHelper.showElementMetaBox({
                                        el, i, isGroup: true, formatMessage: this.formatMessage, labelClass,
                                        viewMode: this.state.viewMode, element: this.state.currentClip
                                    });
                                }
                                return <span key={`clipdetailHeading${i}`}></span>
                            }
                            if (el[`${this.state.viewMode}Html`]) {
                                return (
                                    <h1 className="clipdetail-heading" key={`clipdetailHeading${i}`}>
                                        {this.state.currentClip.metadata.fields[el.field] || ''}
                                    </h1>)
                            }
                            return fieldHelper.showElementMetaBox({
                                el, i, viewMode: this.state.viewMode, labelClass,
                                element: this.state.currentClip, formatMessage: this.formatMessage
                            });
                        })}
                    </div>
                </Fragment>
            )
        }

        onLeftMenuClick = (item) => () => {
            if (item.name === ConfigTypes.OVERVIEW) {
                this.props.updateMediaObjects({ keyword: "", viewMode: ConfigTypes.HOME, currentPage: 1 });
                if (!isHome()) this.props.router.navigate("/");
            }
        }

        showLeftMenu = () => {
            return (
                <div className="clipdetail-leftmenu-box">
                    {ConfigTypes.CLIPDETAIL_LEFTMENU.map((item, i) => {
                        return (
                            <div className="clipdetail-leftmenu-item" key={`clipdetail_leftmenu${i}`}
                                onClick={this.onLeftMenuClick(item)}>
                                {this.props.intl.formatMessage({ id: item.intl })}
                            </div>
                        )
                    })}
                </div>
            )
        }

        showClipImg = ({ isDefault }) => {
            let elementId = "clipDetailImage";
            let fullSrc = getImgUrl({ fullScreen: true, stateCurrentClip: this.state.currentClip });
            if (this.state.fullMediaUrl) fullSrc = this.state.fullMediaUrl;
            let imgUrl;
            if (this.state.mediaTypeObj && this.state.mediaTypeObj.mediaUrl) {
                imgUrl = this.state.mediaTypeObj.mediaUrl;
            }
            if (isDefault) {
                imgUrl = getDefaultImg();
                fullSrc = imgUrl;
            }
            return (
                <div className="clipdetail-img-box">
                    {/* {isDefault && (<div className="clipdetail-img-overlay"></div>)} */}
                    <img className="clipdetail-media" src={imgUrl}
                        onClick={onFullScreenClick(elementId, fullSrc)} id={elementId} />
                </div>)
        }


        showCustomMedia = () => {
            if ((!this.state.loading && this.state.currentClip && !this.props.mediaObjects.loading)
                || this.props.mediaObjects.openVideoPlayer) {
                if (this.state.mediaTypeObj && this.state.mediaTypeObj.type === ConfigTypes.VIDEO) {
                    return (
                        <div className="clipdetail-media-box">
                            <VideoPlayer />
                        </div>)
                }
                if (this.state.mediaTypeObj && this.state.mediaTypeObj.type === ConfigTypes.IMAGE) {
                    return this.showClipImg({});
                }
                return this.showClipImg({ isDefault: true });
            }
        }

        onBackClick = () => {
            const { currentWork, lastView } = this.props.mediaObjects;
            if (lastView === ConfigTypes.WORK_DETAIL) {
                if (currentWork && currentWork.id) {
                    this.props.updateMediaObjects({
                        viewMode: ConfigTypes.WORK_DETAIL, toTop: true,
                        wpView: ConfigTypes.WORK_LIST
                    });
                    this.props.router.navigate(`${ConfigTypes.WORK_PATH}/${currentWork.id}`);
                }
            } else {
                this.props.updateMediaObjects({ viewMode: ConfigTypes.LIST, toTop: true });
                if (!isHome()) this.props.router.navigate("/");
            }
        }

        getPrevNext = (isNext = true) => {
            const { cliplist, currentClip, lastView, objectlist } = this.props.mediaObjects;
            let list = cliplist;
            if (lastView === ConfigTypes.WORK_DETAIL) list = objectlist;
            if (list && list.length) {
                const obj = handleNext({ list: list, current: currentClip, isNext });
                if (obj) {
                    this.props.updateMediaObjects({ viewMode: ConfigTypes.DETAIL, toTop: true, currentClip: obj.nextObj });
                    this.props.router.navigate(`${ConfigTypes.CLIP_PATH}/${obj.nextId}`);
                }
            }
        }

        onNextClick = () => {
            this.getPrevNext();
        }

        onPrevClick = () => {
            this.getPrevNext(false);
        }

        showBackNextBtn = () => {
            return (<div className="clipdetail-navbtns">
                <div className="clipdetail-back" onClick={this.onBackClick}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    {this.props.intl.formatMessage({ id: "clipdetail.showback" })}
                </div>
                <div className="clipdetail-prev" onClick={this.onPrevClick}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    {this.props.intl.formatMessage({ id: "clipdetail.showprev" })}
                </div>
                <div className="clipdetail-next" onClick={this.onNextClick}>
                    {this.props.intl.formatMessage({ id: "clipdetail.shownext" })}
                    <FontAwesomeIcon icon={faArrowRight} />
                </div>
            </div>)
        }

        showFooter = () => {
            return (
                <div className="clipdetail-footer-box">
                    <div></div>
                    {/* {this.showBackNextBtn()} */}
                </div>
            )
        }

        showClipDetail = () => {
            const showFields = getMetaConfig({ viewMode: this.state.viewMode, props: this.props, configName: ConfigTypes.OBJECT })
            if (this.state.currentClip && this.state.currentClip.metadata
                && this.state.currentClip.metadata.fields) {
                return (
                    <div className="clipdetail-page">
                        {this.showBackNextBtn()}
                        <div className="clipdetail-container">
                            <div className="clipdetail-top">
                                {/* {this.showBackNextBtn()} */}
                            </div>
                            <div className="clipdetail-left">
                                {this.showCustomMedia()}
                                <div>
                                    {this.showMediafileInfo()}
                                </div>
                                <div className="clipdetail-medialist-box">
                                    {this.showMediafiles()}
                                </div>
                            </div>
                            <div className="clipdetail-right">
                                {this.showClipContent({ showFields })}
                            </div>
                            <div className="clipdetail-footer">
                                {this.showFooter()}
                            </div>
                        </div>
                    </div>
                )
            }
        }

        componentDidUpdate(prev) {
            if (prev.mediaObjects.currentClip != this.props.mediaObjects.currentClip) {
                this.updateClip();
            }
        }

        componentDidMount() {
            this.updateClip();
        }

        render() {
            return (
                <ContainerBox>
                    <div className="clipdetail">
                        {this.showClipDetail()}
                    </div>
                </ContainerBox>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(ClipDetail))));